const IconPlaneArrival = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="icon-plane-arrival"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M2.278,7.685c.219,2.051,1.512,3.878,3.368,4.764l12.862,6.313c.334,.159,.69,.239,1.048,.239,.286,0,.574-.051,.852-.154,.623-.232,1.114-.696,1.382-1.307,.551-1.258-.021-2.729-1.275-3.287l-3.463-1.733-1.672-8.991c-.082-.912-.655-1.704-1.498-2.069l-.793-.338c-.466-.198-.995-.149-1.419,.13-.421,.28-.672,.75-.67,1.253v6.987l-4.067-2.035-1.263-3.231c-.303-.773-1.076-1.255-1.909-1.208-.497,.03-.954,.263-1.285,.656-.354,.418-.522,.971-.464,1.516l.267,2.495ZM12,2.503c0-.171,.081-.324,.224-.418s.316-.11,.473-.043l.791,.337c.504,.218,.848,.693,.903,1.287l1.541,8.294-3.931-1.967V2.503ZM3.239,4.319c.153-.182,.453-.305,.642-.305,.381,0,.721,.226,.857,.576l1.333,3.41c.045,.115,.132,.209,.242,.265l13.765,6.888,.022,.011c.758,.332,1.104,1.218,.773,1.976-.157,.36-.447,.633-.815,.77-.366,.137-.764,.119-1.113-.047L6.083,11.549c-1.552-.74-2.628-2.262-2.811-3.971l-.267-2.496c-.029-.275,.056-.553,.233-.764ZM24,23.5c0,.276-.224,.5-.5,.5H.5c-.276,0-.5-.224-.5-.5s.224-.5,.5-.5H23.5c.276,0,.5,.224,.5,.5Z" />
    </svg>
  );
};

export default IconPlaneArrival;
